import styles from './RegularProgram.module.css';
import { FaCode, FaRobot, FaCube, FaBrain, FaLaptopCode, FaMicrochip, FaHandsHelping, FaMobileAlt, FaVideo, FaBookOpen, FaPaintBrush, FaTools, FaPencilRuler, FaGraduationCap, FaJsSquare, FaPython } from 'react-icons/fa';

const RegularProgram = () => {
  const programs = [
    {
      level: "Early STEM",
      grade: "Grade 1",
      icon: FaPencilRuler,
      courses: [
        "Scratch Jr Coding",
        "Sequencing",
        "Virtual LEGO Robos",
        "3D Design",
        "Story Telling"
      ]
    },
    {
      level: "Primary",
      grade: "Grade 2-5",
      icon: FaGraduationCap,
      courses: [  
        "Scratch Coding",
        "Virtual LEGO Robotics",
        "Mobile App Development",
        "Virtual Electronics and Circuits",
        "Animation",
        "3D Design in CAD Software",
        "HTML CSS Coding",
        "ROBOTICS with Hardware Kit"
      ]
    },
    {
      level: "Middle School",
      grade: "Grade 6-7",
      icon: FaJsSquare,
      courses: [
        "HTML CSS Coding",
        "JAVA Script Coding",
        "Virtual Electronics with C++ Coding",
        "Junior Python Coding",
        "LEGO Robotics",
        "3D Designing",
        "Mobile App Development",
        "ROBOTICS with Hardware Kit"
      ]
    },
    {
      level: "Secondary",
      grade: "Grade 8-10",
      icon: FaPython,
      courses: [
        "Python Programming",
        "Artificial Intelligence",
        "Machine learning",
        "Python Coding",
        "Virtual Electronics with C++",
        "LEGO Robotics with Python coding",
        "Internet of things",
        "3D Printing"
      ]
    }
  ];

  const features = [
    { name: "Coding", icon: FaCode },
    { name: "Virtual LEGO Robotics", icon: FaRobot },
    { name: "3D Design", icon: FaCube },
    { name: "Artificial Intelligence", icon: FaBrain },
    { name: "Programming", icon: FaLaptopCode },
    { name: "Virtual Electronics", icon: FaMicrochip },
    { name: "HANDS-ON Learning", icon: FaHandsHelping },
    { name: "App Development", icon: FaMobileAlt },
    { name: "Animation", icon: FaVideo },
    { name: "Story telling", icon: FaBookOpen },
    { name: "Graphic Design", icon: FaPaintBrush },
    { name: "Robotics with Hardware Kit", icon: FaTools }
  ];

  return (
    <section className={styles.regularProgram}>
      <div className={styles.container}>
        <h2 className={styles.title}>Live Online STEM Regular Program</h2>
        <h3 className={styles.subtitle}>SCIENCE | TECHNOLOGY | ENGINEERING | MATH</h3>
        <p className={styles.description}>"Online STEM Curriculum with Live Mentor"</p>
        <p className={styles.experience}>3+ Years in Online learning | Labs - Curriculum - Competitions - Support</p>

        <div className={styles.features}>
          {features.map((feature, index) => (
            <div key={index} className={styles.featureCard}>
              <feature.icon size={60} />
              <p>{feature.name}</p>
            </div>
          ))}
        </div>

        <div className={styles.programsGrid}>
          {programs.map((program, index) => (
            <div key={index} className={styles.programCard}>
              <div className={styles.programHeader}>
                <program.icon size={60} />
                <h4>{program.level}</h4>
                <p className={styles.grade}>{program.grade}</p>
              </div>
              <ul className={styles.courseList}>
                {program.courses.map((course, idx) => (
                  <li key={idx}>{course}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RegularProgram; 